<template>
  <div class="cardNewStyle card card-with-shadow border-0 h-100 employee-preview-card">
    <div class="card-body position-relative d-flex flex-column justify-content-between">
      <div v-if="showAction" class="dropdown options-dropdown position-absolute" style="z-index: 999">
        <button
          v-if="profile.status == 'pending' || profile.status == 'rejected'"
          type="button"
          class="btn-option btn d-flex align-items-center justify-content-center"
          data-toggle="dropdown"
        >
          <app-icon name="more-horizontal" />
        </button>
        <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
          <a
            class="dropdown-item px-4 py-2"
            href="#"
            v-for="(action, index) in actions"
            :key="index"
            @click.prevent="callAction(action)"
          >
            {{ action.title }}
          </a>
        </div>
      </div>
      <div class="d-flex flex-column">
        <!-- <app-avatar
          :title="profile.name"
          avatar-class="avatars-w-60 mb-2 d-inline-block"
          :img="getImageUrl(profile)"
        /> -->

        <h5 class="mb-3 mt-3" style="font-size: 1.15rem; color: var(--job-title-color)">
          {{ profile.user.full_name }}
        </h5>
        <small class="mb-3">({{ profile.user.company.company_name }})</small>
        <div v-if="profile.status" class="my-3">
          <span
            :class="
              'text-capitalize badge badge-sm badge-pill badge-' + statusClass(profile.status)
            "
            >{{ profile.status }}</span
          >
        </div>
        <div class="d-flex justify-content-end">
          <a href="#" @click.prevent="view(profile)">View More</a>
        </div>

        <!-- <div class="row">
          <div class="col-sm-4">
            <p class="font-weight-bold" v-for="(header , h) in profile.form_revision.get_bodies.body[0].fields" :key="h">{{header.label}}:</p>
          </div>
          <div class="col-sm-8">
            <p v-for="(body , b) in profile.form_responses" :key="b" v-if="profile.user.id == body.user_id">{{body.value}}</p>
          </div>
        </div> -->

        <!-- <table class="table">
          <tr>
            <th v-for="(data , i) in profile.form.body[0].fields" :key="i">{{data.label}}</th>
          </tr>
          <tr>
            <td v-for="(data , i) in profile.form_responses" :key="i">{{data.value}}</td>
          </tr>
        </table> -->
        <!-- <div class="d-flex">
          <div class="d-block">
            <p v-for="(data , i) in profile.form.body[0].fields" :key="i">
          <span>{{data.label}}</span>
          </p>
          <p v-for="(data , i) in profile.form_responses" :key="i">

            <span>{{data.value}}</span>
          </p>
          </div>
        </div> -->
        <!-- <p class="mb-3 font-size-90">{{ profile.description }}</p>
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <p class="mb-3">
              {{ $t('start_date') + ': ' + profile.start_date }}
            </p>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
            <p class="mb-2">
              {{ $t('end_date') + ': ' + profile.end_date }}
            </p>
          </div>
        </div> -->

        <!-- <p class="mb-2">
          {{ $t("job_type") + ": " + profile.job_type }}
        </p> -->
        
        <!-- <p v-if="profile.phone" class="mb-2">{{ profile.phone }}</p>
        <p v-if="profile.gender" class="mb-2">{{ $t(profile.gender) }}</p>
        <p v-if="profile.age" class="mb-2">
          {{ $t('age') + ': ' + profile.age }}
        </p> -->
      </div>
    </div>
    <job-bid-detailmodal
      v-if="isBidDetailModalActive"
      :data="data"
      @close-modal="closeBidDetailModal"
    />
  </div>
</template>

<script>
import AppFunction from '../../../../../../../core/helpers/app/AppFunction';
export default {
  name: 'ResponseCard',
  props: {
    profile: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      required: true
    },
    showAction: {
      type: Boolean,
      default: true
    },
    id: {
      required: true
    }
  },
  data(){
    return{
      open : false,
      isBidDetailModalActive: false,
      data: {},
    }
  },

  methods: {
    view(data) {
      this.data = data;
      this.isBidDetailModalActive = true;
    },  
    closeBidDetailModal() {
      this.isBidDetailModalActive = false;
      $("#bid-detail-show").modal("hide");
    },
    callAction(action) {
      this.$emit("action-" + this.id, this.profile, action, true);
      // let id = this.profile.id;
    },
    getImageUrl(profile) {
      if (profile.profile_picture) {
        return AppFunction.getAppUrl(profile.profile_picture);
      }
      return AppFunction.getAppUrl('images/avatar-demo.jpg');
    },
    statusClass(status) {
      let ClassName = 'danger';
      if (status === 'accepted') ClassName = `success`;
      else if (status === 'pending') ClassName = `warning`;
      return ClassName;
    },
    closeModal() {
      this.JobModalActive = false;
    }
  },
  mounted() {
    // this.profile.form_revision.get_bodies.body = JSON.parse(this.profile.form_revision.get_bodies.body); 
    
  },
  // watch: {
  //   profile: function (newVal , oldVal) {
  //      this.profile.form_revision.get_bodies.body = JSON.parse(this.profile.form_revision.get_bodies.body); 
  //   },
  // },
  // computed() {
  //      this.profile.form.body = JSON.parse(this.profile.form.body); 
  //   }
};
</script>
<style>

.cardNewStyle {
  border: 0.5px solid #898989 !important;
}

</style>
